<template lang="pug">
p.text-center.txt__notoSB20(
  class="!mb-4"
) タップでリアクションを送る

div(class="grid grid-flow-col auto-cols-max mx-auto gap-4 justify-center lg:gap-11 md:grid-cols-[repeat(3,198px)]")
  VueReactionButton(
    v-for="button in reactionButtons"
    :type="button.type"
    :key="button.type"
    :icon="button.icon"
    :label="button.label"
    :count="reactionData?.counts?.[button.type] ?? 0"
    :active="reactionData?.my_reaction_type === button.type"
    :disabled="isSubmitting"
    @clickReaction="toggleReaction"
  )



</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue';
import axios from 'axios';
// components
import VueReactionButton from '@/vue/components/VueReactionButton.vue';
// types
import type { ReactionType } from '@/ts/public/type/ReactionType';


const baseUrl = (window as any).baseUrl ?? '';

const isSubmitting = ref<boolean>(false);

// リアクションボタンの型
interface ReactionButtonList {
  type: string;
  icon: string;
  label: string;
  color: string;
}

// const reactionIcons: Record<string, string> = {
//   participated: 'how_to_reg',
//   interested: 'distance',
//   support: 'campaign',
// };

const reactionButtons = ref<ReactionButtonList[]>([]);

const reactionData = ref<{
  counts: {
    participated: number;
    interested: number;
    support: number;
  };
  my_reaction_type: string | null;
} | null>(null);

// 親からプロジェクトIDを受け取る
const props = defineProps<{
  projectId: number;
}>();


onMounted(async () => {
  const response = await axios.get(`${baseUrl}/reaction/${props.projectId}`);
  const data = response.data;
  // console.log(data);
  reactionButtons.value = data.types.map((reactionOption: ReactionButtonList) => ({
    type: reactionOption.type,
    icon: reactionOption.icon,
    label: reactionOption.label,
    color: reactionOption.color,
  }));

  console.log(reactionButtons.value);

  reactionData.value = data;
});

const toggleReaction = async (type: ReactionType['type']) => {
  // console.log(type);
  if (!reactionData.value || isSubmitting.value) return;
  isSubmitting.value = true;

  try {
    const response = await axios.post(`${baseUrl}/reaction/${props.projectId}`, {
      reaction_type: type,
    })
    reactionData.value = response.data;
    // console.log(reactionData.value);
  } catch (error) {
    console.error(error);
  } finally {
    isSubmitting.value = false;
  }
}


</script>

<style lang="sass" scoped>

</style>